import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';

@Component({
  selector: 'app-investor',
  templateUrl: './investor.component.html',
  styleUrls: ['./investor.component.scss']
})
export class InvestorComponent implements OnInit {

  public title: string;
  public nameActive: any;
  public phoneActive: any;
  public emailActive: any;
  public show_msg:any;
  public submit_form:boolean;
  public investorDetails = {name: "" , phone: "" , email: "" , year: ""};

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    window.scrollTo(0,0);
    this.title = "Investor Information";
    let currentYear = moment().format('YYYY');
    let nextYear = (parseInt(moment().format('YY')) + 1).toString();
    this.investorDetails.year = currentYear + '-' + nextYear;
  }
  

  public selectedYear(year: string){
    this.investorDetails.year = year;
  }
  
  public onNameChange(value: string){
    this.investorDetails.name = value;
  }

  public onPhoneChange(value: string){
    this.investorDetails.phone = value;
  }

  public onEmailChange(value: string){
    this.investorDetails.email = value;
  }

  public submitInvestorForm(){
    let validate = this.validator();
    if(validate == true){
      this.show_msg = "We have recieved your details. Thank you.";
      this.submit_form = true;
    }else{
      this.show_msg = "Please fill in all the details.";
      this.submit_form = false;
    }
  }

  public validator(){
    if(this.investorDetails.name == "" || this.investorDetails.phone  == ""  || this.investorDetails.email == ""){
      
      return false;
    }
    return true;
  }
}
